import Response from '../base/Response';

export default class NoAccessResponse extends Response {

}
